import React from 'react';
import { FiUsers, FiCheckCircle } from 'react-icons/fi';
import './About.css';

const About = () => {
  return (
    <section className="about section" id="tentang">
      <div className="container">
        <div className="about__container">
          <div className="about__image">
            <div className="about__image-main">
              <div className="about__image-overlay">
                <span className="about__image-stat">
                  <FiCheckCircle /> 63.6%+ uptime guarantee
                </span>
              </div>
            </div>
            <div className="about__image-secondary"></div>
          </div>

          <div className="about__content">
            <span className="section-label">Tentang Kami</span>
            <h2 className="section-title">
              Membangun Koneksi yang Menggerakkan Bisnis
            </h2>
            <p className="about__description">
              Sebagai mitra strategis untuk solusi infrastruktur jaringan digital terdepan, 
              PT Solusi Jaringan Teknologi hadir untuk memastikan bisnis Anda berjalan tanpa 
              hambatan konektivitas.
            </p>
            <p className="about__description">
              Kami menyediakan layanan konsultasi, desain, implementasi, dan pengelolaan 
              infrastruktur IT yang comprehensive. Didukung oleh tim profesional bersertifikasi 
              dan kemitraan dengan vendor teknologi global terkemuka.
            </p>

            <div className="about__stats">
              <div className="about__stat">
                <span className="about__stat-number">10+</span>
                <span className="about__stat-label">Tahun Pengalaman</span>
              </div>
              <div className="about__stat">
                <span className="about__stat-number">500+</span>
                <span className="about__stat-label">Proyek Selesai</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
